import React, { useState } from "react";
import { motion } from "framer-motion";
import CMSRender from "aldoo-ra/CMS/cms-render";
import Typography from "aldoo-ra/Typography";
import PricingFooterContact from "./PricingPage/PricingFooterContact";
import { ChevronDownIcon } from "@heroicons/react/24/outline"

const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="py-[20px] md:pt-[40px] md:pb-[30px]">
      <button
        onClick={onClick}
        className="flex justify-between items-center w-full text-left focus:outline-none group"
      >
        <Typography 
          variant="body1_accent" 
          className="my-0"
        >
          {question}
        </Typography>

        <div
          className={`w-[25px] h-[25px] flex items-center justify-center flex-shrink-0 ml-2 md:ml-4 mr-2 md:mr-6 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <ChevronDownIcon className="w-5 h-5 text-primary" />
        </div>
      </button>
      
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
        transition={{ duration: 0.3 }}
        className="overflow-hidden"
      >
        <Typography
          variant="body1" 
          className="mt-[30px] md:pr-12"
        >
          {answer}
        </Typography>
      </motion.div>
    </div>
  )
}

const Accordion = ({ items, title }) => {
  const [openIndex, setOpenIndex] = useState(null)

  const handleAccordionClick = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="flex flex-col justify-between mb-[56px]">
      <Typography 
        component="h2"
        variant="h1" 
        className="text-text text-center mb-[70px]">
        {title}
      </Typography>
      
      <div className="w-full md:max-w-[820px] lg:w-[820px] bg-paper rounded-[50px] px-7 md:px-[50px] py-[10px] shadow-[0_0_20px_0_rgba(0,0,0,0.06)] mx-auto">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <AccordionItem
              question={item.title}
              answer={item.answer}
              isOpen={openIndex === index}
              onClick={() => handleAccordionClick(index)}
            />
            {index < items.length - 1 && (
              <div className="border-t border-1 border-bordered" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

const FAQ = () => {
  return (
    <div 
      className="w-full px-4 md:px-px1_l lg:px-px1_xl pt-[115px] pb-[110px] bg-gradient_bottom_page rounded-b-[50px] md:rounded-b-[100px]"
    >
      <CMSRender
        contentType="FAQ Section"
        renderItem={(data, id) => {
          return (
            <Accordion key={id} items={data.questions} title={data.title} />
          )
        }}
      />
      <PricingFooterContact />
    </div>
  )
}

export default FAQ